'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.getTextHeight = getTextHeight;

var _stringPixelWidth = require('string-pixel-width');

var _stringPixelWidth2 = _interopRequireDefault(_stringPixelWidth);

var _lodash = require('lodash.sum');

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = require('lodash.words');

var _lodash4 = _interopRequireDefault(_lodash3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getTextHeight(text, _ref) {
    var textBlockWidth = _ref.textBlockWidth,
        _ref$lineHeight = _ref.lineHeight,
        lineHeight = _ref$lineHeight === undefined ? 1.15 : _ref$lineHeight,
        fontSize = _ref.fontSize;

    var paragraphs = text.split('\n');
    var lineCountPerParagraph = paragraphs.map(function (paragraph) {
        var words = (0, _lodash4.default)(paragraph);

        var _words$reduce = words.reduce(function (_ref2, word) {
            var _ref3 = _slicedToArray(_ref2, 2),
                lines = _ref3[0],
                line = _ref3[1];

            var expandedLine = line ? line + ' ' + word : word;
            var estimatedUnwrappedLineWidth = (0, _stringPixelWidth2.default)(expandedLine, { size: fontSize });
            if (estimatedUnwrappedLineWidth <= textBlockWidth) {
                return [lines, expandedLine];
            }
            return [lines + 1, word];
        }, [1, '']),
            _words$reduce2 = _slicedToArray(_words$reduce, 1),
            lineCount = _words$reduce2[0];

        return lineCount;
    });
    var totalLineCount = (0, _lodash2.default)(lineCountPerParagraph);
    return totalLineCount * fontSize * lineHeight;
}

exports.default = getTextHeight;